module.exports = __webpack_public_path__ + "img/ic-pt-ring.430481c5.svg";